"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCoreSonarObjectsSalesforceUpdateableAsyncSlice = void 0;
const _api_1 = require("../../../api/index.js");
const actions_1 = require("../_idMap/actions.js");
const xuder_1 = require("@sonar-software/xuder");
exports.postCoreSonarObjectsSalesforceUpdateableAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        successDataActionCreators: [
            (response) => (0, actions_1.updateSonarObjectReferences)(response === null || response === void 0 ? void 0 : response.map((_a) => {
                var { sonarObjectId } = _a, salesforce = __rest(_a, ["sonarObjectId"]);
                return ({
                    salesforce: Object.assign(Object.assign(Object.assign({}, salesforce.complianceCategory ?
                        { complianceCategory: salesforce.complianceCategory } : {}), salesforce.dataSensitivityLevelId ?
                        { dataSensitivityLevelId: salesforce.dataSensitivityLevelId } : {}), salesforce.fieldUsageId ?
                        { fieldUsageId: salesforce.fieldUsageId } : {}),
                    sonarObjectId
                });
            }))
        ]
    },
    name: 'CoreSonarObjectsSalesforceUpdateable',
    receive: true,
    request: true,
    requestHandler: _api_1.postSonarObjectSalesforceUpdateable,
    yieldType: xuder_1.SagaYieldType.Latest
});
//# sourceMappingURL=post.js.map